/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { IndexTablePopup } from '../../styled/portfolio';
import { Text } from '../alert-modals/Text';
import { Title } from '../alert-modals/Title';

export type EmptyIndexPortfolioPopupProps = ComponentProps<
  typeof IndexTablePopup
>;

const EmptyIndexPortfolioPopup = (props: EmptyIndexPortfolioPopupProps) => {
  const { t } = useTranslation();

  // <IndexTablePopup square={false} {...props}>
  return (
    <IndexTablePopup {...props}>
      <Title>{t('INDEX_PORTFOLIO_GRAPTH_EMPTY_PORTFOLIO_POPUP__title')}</Title>
      <Text>{t('INDEX_PORTFOLIO_GRAPTH_EMPTY_PORTFOLIO__desc')}</Text>
    </IndexTablePopup>
  );
};

export { EmptyIndexPortfolioPopup };
